import { TranslationUserRegisterMessages, UserRegisterMessages } from "../interfaces";

export const messages: TranslationUserRegisterMessages = {
  [UserRegisterMessages.titleCreate]: "Crear usuario",
  [UserRegisterMessages.titleEdit]: "Editar usuario",
  [UserRegisterMessages.stepTabFormUser]: "Datos del usuario",
  [UserRegisterMessages.stepTabAddUserToRoles]: "Agregar a grupos",
  [UserRegisterMessages.stepTabModuleAccess]: "Acceso a módulos",
  [UserRegisterMessages.roleNotSelected]: "No es posible continuar, ya que no se seleccionó ningún grupo",
  [UserRegisterMessages.roleNotFound]: "El grupo seleccionado no se encontró",
  [UserRegisterMessages.noRolesRegistered]: "No hay grupos registrados",
  [UserRegisterMessages.confirmUserEditModalTitle]: "Confirmación de cambio",
  [UserRegisterMessages.confirmUserEditModalDescription]: "Estás guardando un usuario sin grupo."
    + " Si tiene permisos personalizados, se perderán. ¿Estás seguro de que quieres continuar?",
  [UserRegisterMessages.confirmUserInactivateModalTitle]: "Confirmación de inactivación",
  [UserRegisterMessages.confirmUserInactivateModalDescription]: "Al confirmar, el usuario será inactivado de todas las soluciones de Topcon. "
      + "Estás seguro de que quieres continuar?",
  [UserRegisterMessages.moduleAccessTitle]: "Acceso a módulos",
  [UserRegisterMessages.moduleAccessCaption]: "Define qué productos puede ingresar el usuario. Los grupos y permisos viven dentro de cada producto"
    + " y requieren que el acceso al módulo sea concedido primero.",
  [UserRegisterMessages.moduleAccessNoModules]: "No hay módulos disponibles para esta empresa.",
  [UserRegisterMessages.moduleAccessSaveSuccess]: "Accesos a módulos actualizados.",
  [UserRegisterMessages.moduleAccessSaveError]: "Error al guardar accesos a módulos.",
  [UserRegisterMessages.moduleAccessNoChanges]: "No hay cambios pendientes.",
  [UserRegisterMessages.moduleAccessAdminNotice]: "Este usuario es administrador y tiene acceso automático a todos los módulos"
    + " contratados por la empresa. El acceso no se puede modificar manualmente."
};